import { InfoOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

interface InformationCardProps {
  text: string;
}

export default function InformationCard({ text }: InformationCardProps) {
  return (
    <Box
      sx={{
        backgroundColor: '#F2F2F2',
        width: '100%',
        borderRadius: '12px',
        height: 'auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        p: 2,
        mt: 2,
      }}
    >
      <InfoOutlined sx={{ color: '#9A9A9A' }} />
      <Typography sx={{ ml: 2 }} color="#797979" variant="caption">
        {text}
      </Typography>
    </Box>
  );
}
